import React from 'react'
import PropTypes from 'prop-types'

const withSettingsCard = WrappedComponent => {

  return class Container extends React.Component {

    static propTypes = {
      style: PropTypes.object
    }

    render() {
      return (
        <div style={{ ...styles.container, ...this.props.style }}>
          <div style={styles.card}>
            <WrappedComponent {...this.props} />
          </div>
        </div>
      )
    }

  }

}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    width: 600,
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px 0 rgba(171, 171, 171, 0.5)'
  }
}

export default withSettingsCard



// WEBPACK FOOTER //
// ./src/settings/modules/withSettingsCard.js